function checkControls(swiper) {
    if (!swiper) return;

    const slidesVisible =
        swiper.params.slidesPerView === "auto"
            ? swiper.slidesPerViewDynamic()
            : Math.ceil(swiper.params.slidesPerView);

    const shouldHide = swiper.slides.length <= slidesVisible;

    if (swiper.pagination && swiper.pagination.el) {
        [].concat(swiper.pagination.el).forEach(function (el) {
            el.style.display = shouldHide ? "none" : "flex";
        });
    }

    if (swiper.navigation && swiper.navigation.nextEl) {
        [].concat(swiper.navigation.nextEl).forEach(function (el) {
            el.style.display = shouldHide || swiper.isEnd ? "none" : "flex";
        });
    }

    if (swiper.navigation && swiper.navigation.prevEl) {
        [].concat(swiper.navigation.prevEl).forEach(function (el) {
            el.style.display = shouldHide || swiper.isBeginning ? "none" : "flex";
        });
    }

    const hasButtons = !!(
        swiper.navigation &&
        (swiper.navigation.nextEl || swiper.navigation.prevEl)
    );

    if (swiper.el && swiper.el.parentElement) {
        swiper.el.parentElement.classList.toggle(
            "padding-for-buttons",
            hasButtons && !shouldHide
        );
    }
}

setTimeout(() => {
    if (swiperAdmin) {
        checkControls(swiperAdmin);
    }
    if (swiperIntegration) {
        checkControls(swiperIntegration);
    }
    if (swiperPrices) {
        checkControls(swiperPrices);
    }
    if (swiperOpinions) {
        checkControls(swiperOpinions);
    }
    if (swiperNews) {
        checkControls(swiperNews);
    }
    if (swiperGallery) {
        checkControls(swiperGallery);
    }
    if (swiperSliderOpinions) {
        checkControls(swiperSliderOpinions);
    }
}, 10);

window.addEventListener("resize", function () {
    if (swiperAdmin) {
        checkControls(swiperAdmin);
    }
    if (swiperIntegration) {
        checkControls(swiperIntegration);
    }
    if (swiperPrices) {
        checkControls(swiperPrices);
    }
    if (swiperOpinions) {
        checkControls(swiperOpinions);
    }
    if (swiperNews) {
        checkControls(swiperNews);
    }
    if (swiperGallery) {
        checkControls(swiperGallery);
    }
    if (swiperSliderOpinions) {
        checkControls(swiperSliderOpinions);
    }
});

const swiperAdmin = new Swiper(".admin-swiper", {
    slidesPerView: 1.2,
    spaceBetween: 24,
    grabCursor: true,
    loop: false,

    navigation: {
        nextEl: ".section-admin .swiper-button-next",
        prevEl: ".section-admin .swiper-button-prev",
    },

    breakpoints: {
        800: {
            slidesPerView: 2,
        },
        1101: {
            slidesPerView: 3,
        },
        on: {
            init: function () {
                checkControls(this);
            },
            resize: function () {
                checkControls(this);
            },
        },
    },
});

if (swiperAdmin) {
    swiperAdmin.on("slideChange", () => checkControls(swiperAdmin));
}

const swiperIntegration = new Swiper(".integration-swiper", {
    slidesPerView: 1.2,
    spaceBetween: 0,
    grabCursor: true,
    loop: false,

    navigation: {
        nextEl: ".section-integration .swiper-button-next",
        prevEl: ".section-integration .swiper-button-prev",
    },

    breakpoints: {
        800: {
            slidesPerView: 2.2,
        },
        1101: {
            slidesPerView: 4,
        },
        on: {
            init: function () {
                checkControls(this);
            },
            resize: function () {
                checkControls(this);
            },
        },
    },
});

if (swiperIntegration) {
    swiperIntegration.on("slideChange", () => checkControls(swiperIntegration));
}

const swiperPrices = new Swiper(".prices-swiper", {
    slidesPerView: 1.5,
    spaceBetween: 32,
    initialSlide: 1,
    centeredSlides: true,
    grabCursor: true,
    loop: false,

    navigation: {
        nextEl: ".section-price .swiper-button-next",
        prevEl: ".section-price .swiper-button-prev",
    },

    breakpoints: {
        800: {
            slidesPerView: 2,
            initialSlide: 1,
            centeredSlides: true,
        },
        1101: {
            slidesPerView: 3,
            initialSlide: 0,
            centeredSlides: false,
        },
    },

    on: {
        init: function () {
            checkControls(this);
        },
        resize: function () {
            checkControls(this);
        },
    },
});

if (swiperPrices) {
    swiperPrices.on("slideChange", () => checkControls(swiperPrices));
}

const swiperOpinions = new Swiper(".opinions-swiper", {
    slidesPerView: 1.2,
    spaceBetween: 24,
    grabCursor: true,
    loop: false,

    navigation: {
        nextEl: ".section-opinions .swiper-button-next",
        prevEl: ".section-opinions .swiper-button-prev",
    },

    breakpoints: {
        800: {
            slidesPerView: 2,
        },
        1101: {
            slidesPerView: 3,
        },
        on: {
            init: function () {
                checkControls(this);
            },
            resize: function () {
                checkControls(this);
            },
        },
    },
});

if (swiperOpinions) {
    swiperOpinions.on("slideChange", () => checkControls(swiperOpinions));
}

const swiperNews = new Swiper(".news-swiper", {
    slidesPerView: 1.2,
    spaceBetween: 24,
    grabCursor: true,
    loop: false,

    navigation: {
        nextEl: ".section-news .swiper-button-next",
        prevEl: ".section-news .swiper-button-prev",
    },

    breakpoints: {
        800: {
            slidesPerView: 2,
        },
        1101: {
            slidesPerView: 3,
        },
        on: {
            init: function () {
                checkControls(this);
            },
            resize: function () {
                checkControls(this);
            },
        },
    },
});

if (swiperNews) {
    swiperNews.on("slideChange", () => checkControls(swiperNews));
}

const swiperGallery = new Swiper(".swiper-gallery", {
    slidesPerView: 1.2,
    spaceBetween: 24,
    grabCursor: true,
    loop: false,
    freeMode: true,

    navigation: {
        nextEl: ".section-gallery .swiper-button-next",
        prevEl: ".section-gallery .swiper-button-prev",
    },

    scrollbar: {
        el: ".section-gallery .swiper-scrollbar",
        draggable: true,
        snapOnRelease: false,
    },

    breakpoints: {
        800: {
            slidesPerView: 2,
        },
        1101: {
            slidesPerView: 3,
        },
        on: {
            init: function () {
                checkControls(this);
            },
            resize: function () {
                checkControls(this);
            },
        },
    },
});

const swiperSliderOpinions = new Swiper(".opinions-slider-swiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    grabCursor: true,
    loop: false,

    // navigation: {
    //     nextEl: ".section-opinions .swiper-button-next",
    //     prevEl: ".section-opinions .swiper-button-prev",
    // },

    pagination: {
        el: '.section-slider-opinions .swiper-pagination',
        clickable: true,
    },

    breakpoints: {
        800: {
            slidesPerView: 2,
        },
        1101: {
            slidesPerView: 3,
        },
    },

    on: {
        init: function () {
            checkControls(this);
        },
        resize: function () {
            checkControls(this);
        },
    },
});


if (swiperGallery) {
    swiperGallery.on("slideChange", () => checkControls(swiperGallery));
}

if (swiperSliderOpinions) {
    swiperSliderOpinions.on("slideChange", () => checkControls(swiperSliderOpinions));
}
